import { CommonModule, DatePipe, NgIf } from '@angular/common'
import { Component, Input, OnChanges } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { ButtonComponent } from '@progress/kendo-angular-buttons'
import { DateInputCustomFormatPlaceholder, DatePickerComponent } from '@progress/kendo-angular-dateinputs'
import { AddCommandDirective, CancelCommandDirective, CellTemplateDirective, ColumnComponent, CommandColumnComponent, DataBindingDirective, EditCommandDirective, EditTemplateDirective, FocusableDirective, GridComponent, GridToolbarFocusableDirective, RemoveCommandDirective, SaveCommandDirective, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { TextBoxDirective } from '@progress/kendo-angular-inputs'
import { ClientServices } from '../../../../@theme/services/clients.service'
import { TypesServices } from '../../../../@theme/services/typeslist.service'
import { RepCode } from '../../../../models/repEditorModels'
import { Utilities } from '../../../../utilities/utilities'
import { GridEditorBaseComponent } from '../../shared/rep-editor-base/grid-editor-base-component'
import { RepEditorStateService } from '../../shared/rep-editor-state.service'
import { AdminOnlyDirective } from '../shared/admin-only.directive'

@Component({
    selector: 'gd-rep-editor-rep-codes',
    templateUrl: './rep-editor-rep-codes.component.html',
    styleUrls: ['./rep-editor-rep-codes.component.scss'],
    imports: [
      CommonModule,
          GridComponent,
        DataBindingDirective,
        ToolbarTemplateDirective,
        GridToolbarFocusableDirective,
        AddCommandDirective,
        ButtonComponent,
        ColumnComponent,
        EditTemplateDirective,
        TextBoxDirective,
        FormsModule,
        ReactiveFormsModule,
        CellTemplateDirective,
        DatePickerComponent,
        CommandColumnComponent,
        FocusableDirective,
        EditCommandDirective,
        NgIf,
        RemoveCommandDirective,
        SaveCommandDirective,
        CancelCommandDirective,
        DatePipe,
        AdminOnlyDirective
    ]
})
export class RepEditorRepCodesComponent
  extends GridEditorBaseComponent
  implements OnChanges
{
  @Input() override repId: number = 0
  repCodes: any[]
  public asDateInput = (value) =>
    Utilities.asType<DateInputCustomFormatPlaceholder>(value)

  constructor(
    typesService: TypesServices,
    clientService: ClientServices,
    formBuilder: UntypedFormBuilder,
    repEditorStateService: RepEditorStateService,
  ) {
    super(typesService, clientService, formBuilder, repEditorStateService)
  }

  ngOnChanges() {
    this.checkGridState()

    if (!this.repState.repCodes) {
      this.initGrid()
    }
  }
  initGrid() {
    this.clientService
      .getRepCodesForRep({ repId: this.repId })
      .subscribe((response) => {
        this.repState.repCodes = response.map((rc) => new RepCode(rc))
      })
  }
  public addHandler({ sender }) {
    const newRepCode = new RepCode(null)
    newRepCode.repID = this.repId
    newRepCode.active = true
    this.addHandlerShared({ sender }, newRepCode)
  }

  public saveHandler({ sender, rowIndex, formGroup, isNew }): void {
    const repCode = new RepCode(formGroup.value)
    this.clientService.submitRepCodeUpdate(repCode).subscribe(() => {
      sender.closeRow(rowIndex)
      this.initGrid()
    })
  }

  public removeHandler({ dataItem }) {
    const itemToRemove = new RepCode(dataItem)
    itemToRemove.active = false
    this.clientService.submitRepCodeUpdate(itemToRemove).subscribe(() => {
      this.initGrid()
    })
  }
  public createFormGroup(repCode: RepCode): UntypedFormGroup {
    return this.formBuilder.group({
      repCodeId: repCode.repCodeId,
      repID: repCode.repID,
      repCode: [repCode.repCode, Validators.required],
      repTitle: [repCode.repTitle, Validators.required],
      repType: repCode.repType,
      startDate: repCode.startDate,
      endDate: repCode.endDate,
      bankRep: repCode.bankRep,
      active: repCode.active,
    })
  }
}
